import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Visible } from 'react-grid-system'
import { useTranslation } from 'react-i18next'

import { Icon } from 'pyrexx-react-library'

const BackButton = (props) => {
  const { prevStep } = props

  const { t } = useTranslation()

  return (
    <LinkStyled to={prevStep}>
      <Visible xs sm>
        <Icon icon='arrow-left' size='20px' />
      </Visible>
      <Visible md lg xl>
        <Icon icon='arrow-left' size='35px' />
        {t('BACK')}
      </Visible>
    </LinkStyled>
  )
}

const LinkStyled = styled(Link)`
  display: flex;
  align-items: center;
  color: #4ab4e2;
  text-decoration: none;
`

export default BackButton
